import {TextField, Autocomplete} from "@mui/material";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";


export default function AutoMultiRuleDialog(props: any) {
    let {authTokens, serverIP} = useContext(AuthContext)

    const {name, mapData, val, dialRule, setDialRule, condObject} = props

    let prevVal: any = val ? JSON.parse(val) : []

    const [valuesArr, setValuesArr] = useState<any>([])

    const queryData: any = {...mapData, thisRule: dialRule, condObj: condObject};

    return (

        <Autocomplete
            value={prevVal}

            onChange={(event, newValue: any) => {
                if (newValue) {
                    setDialRule((prev: any) => {
                        return {...prev, [name]: JSON.stringify(newValue)}
                    })

                    // 'custom_value' detector
                    // if (!valuesArr.includes(newValue.at(-1))) {
                    //     console.log('Customvalue')
                    // } else {
                    //     console.log('in arr')}

                } else {
                    setDialRule((prev: any) => {
                        return {...prev, values: '[]'}
                    })
                }

            }}

            // onInputChange={(event, newValue) => {
            //     // console.log('Custom:', newValue)
            // }}

            multiple
            filterSelectedOptions
            disablePortal
            forcePopupIcon={false}
            id="values-complete"
            freeSolo
            autoSelect    // when user lose focus on the input - the current value will be the value of the autocomplete.
            // defaultValue={[]}
            // size="small"
            options={valuesArr}
            clearOnEscape={true}
            sx={{width: "auto"}}

            ListboxProps={
                {
                    style: {
                        fontSize: "0.8rem",
                        fontFamily: "'Inter', sans-serif",
                        color: "black"
                    }
                }}

            renderInput={(params) => <TextField
                {...params}
                multiline={true}
                minRows={3}
                label=""
                style={{backgroundColor: "white"}}
                onClick={(event) => {
                    // console.log('clicked')

                    fetch(`${serverIP}/getsrcfeatvals/`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + String(authTokens.access)
                        },
                        body: JSON.stringify(queryData),
                    }).then(res => res.json())
                        .then((data) => {
                            // console.log(data)
                            setValuesArr(data)
                        })

                }}
            />}
        />

    );
}


